import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import style from "./style";
import { DescriptionField } from "components/support";

const table = data => {
  return data.map((data, index) => (
    <Row key={index}>
      <Col xs={12}>
        <DescriptionField label={data.name} value={data.origin} />
      </Col>
    </Row>
  ));
};

class CompanyIntegrationsOderIntegrationView extends Component {
  render() {
    const { viewModel, className } = this.props;
    const { data } = viewModel;
    return (
      <div className={`${className} grid-container`}>
        {data.length > 0 ? (
          table(data)
        ) : (
          <p>Não há integrações a serem mostradas.</p>
        )}
      </div>
    );
  }
}

export default style(CompanyIntegrationsOderIntegrationView);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/order_integrations/view.jsx